<template>
  <div
    class="progress-container"
  >
    <div class="m-medium-top" />
    <div class="p-medium">
      <p
        v-if="routeId === 'iStock'"
        class="tertiary-link xsmall top-margin-zero"
      >
        <a
          ref="contactLink"
          href="#"
          @click.prevent="handleClick()"
        >
          {{ contactUsLink }}
          <pvd-icon
            class="m-xsmall-left"
            icon="new-tab"
          />
        </a>
      </p>
      <p
        v-if="routeId !== 'iStock'"
        class="tertiary-link xsmall top-margin-zero"
      >
        <a
          id="question-overlay-modal-trigger"
          ref="contactLink"
          href="javascript:void(0);"
          @click="handleQuestionClick()"
        >
          {{ pd_content.questions_link }}</a>
      </p>
      <ModalComponent
        v-if="routeId !== 'iStock'"
        :modal-header="pd_content.question_overlay_modal_header"
        :modal-body1="pd_content.question_overlay_modal_body1"
        :modal-link-url="pd_envConfig.repChatURL"
        :modal-link-val="pd_content.rep_chat_link"
        body-class="xlarge m-xxsmall-top"
        modal-class="xsmall"
        id-val="question-overlay-modal"
        @exitmodal-action="openChatWindow"
      />
    </div>
  </div>
</template>

<script>
import dataHelper from '../mixins/dataHelper';
import measurement from '../mixins/measurement';
import utility from '../mixins/utility';
import ModalComponent from './ModalComponent.vue';

export default {
  name: 'ProgressBar',
  components: {
    ModalComponent,
  },
  mixins: [
    dataHelper,
    measurement,
    utility,
  ],
  props: {
    activeStep: {
      type: String,
      default: '',
    },
  },
  computed: {
    contactUsLink() {
      return this.pd_content.contact_us_link ? this.pd_content.contact_us_link.value : 'Contact us';
    },
  },
  mounted() {
    this.$refs.contactLink.focus();
  },
  methods: {
    closeModal() {
      document.querySelector('#question-overlay-modal').setAttribute('active', 'false');
    },
    handleQuestionClick() {
      this.track('questions-link', 'interaction');
    },
    openChatWindow(url) {
      this.track('rep-chat-link', 'interaction');
      this.closeModal();
      this.openWindow(url, 'mainwindow', '650', '650');
    },
    handleClick() {
      this.track('contact-us-link', 'interaction');
      // ToDo: extend this to work with multiple regtypes
      const url = this.pd_content.contact_us_link ? this.pd_content.contact_us_link.url : 'https://nb.fidelity.com/public/nb/default/resourceslibrary/articles/HowtoContactaFidelitySPSRep';
      this.openWindow(url, 'mainwindow', '1024', '500');
    },
  },
};
</script>

<style lang="scss">
   .top-margin-zero {
     margin-top: 0;
   }
  .progress-container {
    background-color: #fff;
    border-bottom: 1px solid #ccc;
    display:-ms-flexbox;
    display:flex;
    -ms-flex-preferred-size:100%;
    flex-basis:100%;
    -ms-flex-pack:justify;
    justify-content:space-between;
    -ms-flex-align:center;
    align-items:center;
  }
</style>
